import React, { Fragment, useEffect, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Auftragsvorlage, MandantSummary } from '../../../../api';
import { UserSessionModel } from '../../../../models/UserSessionModel';
import {
  StateModel,
  StateModel_Benutzererfassung,
} from '../../../../redux/store';
import Toolbar from '../../../../components/toolbar/Toolbar';
import Button from '../../../../components/button/Button';
import InputFieldText from '../../../../components/input/floating-label/input-field/InputFieldText';
import Table from '../../../../components/table/Table';
import { initAuftragsvorlageManagementTableConfig } from './AuftragsvorlageSucheTableConfig';
import { connect } from 'react-redux';
import GridCellWrapper from '../../../../components/grid-cell-wrapper/GridCellWrapper';
import {
  deleteAuftragsvorlage,
  searchAuftragsvorlage,
  setVorlageAuftragId,
} from '../../../../redux/actions/auftragsvorlage';
import { setNotification } from '../../../../utils/notificationUtils';
import { setActiveTab } from '../../../../redux/actions/routing';
import { History } from 'history';
import { ERROR } from '../../../notification/Notification';
import { getMandantenByHauptmandant } from '../../../../redux/actions/mandant';
import Select from '../../../../components/select/Select';
import { toSelectOptions } from '../../../../components/select/SelectModel';
import Pagination from '../../../../components/pagination/Pagination';

interface AuftragsvorlageManagementProps {
  getCurrentBenutzer: () => void;
  searchAuftragsvorlage: (
    searchParam: string,
    page: number,
    searchLimit: number,
    mandantId: number | undefined
  ) => void;
  auftragsvorlageliste: Auftragsvorlage[];
  resetBenutzererfassung: () => void;
  benutzererfassung: StateModel_Benutzererfassung;
  reloadToggle: boolean;
  setVorlageAuftragId: (id: number) => void;
  setActiveTab: (tab: string) => void;
  history: History;
  mandantenByHauptmandant: MandantSummary[];
  getMandantenByHauptmandant: () => void;
  deleteAuftragsvorlage: (id: number) => void;
  session: UserSessionModel;
  version: number;
  rowsInGrid: number;
  totalSearchResults: any;
}

/**
 * AuftragsvorlageManagement-Component
 *
 * @returns {JSX.Element} AuftragsvorlageManagement-Component
 * @constructor
 */
const AuftragsvorlageManagement = (
  props: AuftragsvorlageManagementProps & RouteComponentProps
) => {
  const [query, setQuery] = useState<string>('');
  const [data, setData] = useState<Array<any>>([{}]);
  const [selectedRow, setSelectedRow] = useState<any>(undefined);
  const [tableConfig, setTableConfig] = useState(
    initAuftragsvorlageManagementTableConfig()
  );
  const [mandanten, setMandanten] = useState<MandantSummary[]>([]);
  const [selectedMandant, setSelectedMandant] = useState<
    MandantSummary | undefined
  >(undefined);
  const [page, setPage] = useState(1);

  const canDeleteTemplate =
    props.version === 0 || (props.version > 0 && props.session.isMain);

  const applyAuftragsvorlage = () => {
    if (selectedRow || selectedRow == 0) {
      const vorlageId: number = data[selectedRow].id;
      if (vorlageId) {
        const vorlage = props.auftragsvorlageliste.find(
          vl => vl.id === vorlageId
        );
        if (vorlage && vorlage.auftrag && vorlage.auftrag.id) {
          props.setVorlageAuftragId(vorlage.auftrag.id);
          props.setActiveTab('auftragsmanagement');
          props.history.push(`/auftragsmanagement/auftragserfassung`);
        } else {
          setNotification('Technischer Fehler aufgetreten', [], ERROR);
        }
      }
    } else {
      setNotification('Bitte markieren Sie eine Zeile.', []);
    }
  };

  useEffect(() => {
    searchStart(page);
  }, [props.reloadToggle]);

  useEffect(() => {
    searchStart(1);
  }, [query, selectedMandant]);

  useEffect(() => {
    setData(
      props.auftragsvorlageliste
        ? convertAuftragsvorlageIntoResearchList()
        : [{}]
    );
  }, [props.auftragsvorlageliste]);

  useEffect(() => {
    getMandantenByHauptmandant();
  }, []);

  useEffect(() => {
    setMandanten(props.mandantenByHauptmandant);
  }, [props.mandantenByHauptmandant]);

  const searchStart = (page: number) => {
    setPage(page);
    props.searchAuftragsvorlage(
      query,
      page,
      props.rowsInGrid,
      selectedMandant?.id ?? +props.session.currentMandantId
    );
  };

  /**
   * Konvertiert Benutzer in das AuftragsvorlageManagementTableModel zur visualisierung in der Tabelle
   */
  const convertAuftragsvorlageIntoResearchList = (): Array<any> => {
    let tmpList = [...props.auftragsvorlageliste];
    tmpList = tmpList.sort((a, b) => {
      if (a?.vorlageName && b?.vorlageName) {
        return a.vorlageName
          .toLowerCase()
          ?.localeCompare(b.vorlageName.toLowerCase(), 'de-DE');
      }
      return a.vorlageName ? -1 : 1;
    });
    return tmpList.map((auftragsvorlage, index: number) => {
      index++;
      return {
        id: auftragsvorlage.id,
        name: auftragsvorlage.vorlageName,
        mandant: auftragsvorlage.mandant?.name,
        frankatur: auftragsvorlage.auftrag?.frankatur?.kurzBezeichnung,
        verkehrsart: auftragsvorlage.auftrag?.verkehrsart?.kurzBezeichnung,
        empfaenger:
          auftragsvorlage.auftrag?.empfaengerAdresse === null
            ? ''
            : auftragsvorlage.auftrag?.empfaengerAdresse.name +
              ' ' +
              (auftragsvorlage.auftrag?.empfaengerAdresse.zeile2 ?? '') +
              ', ' +
              auftragsvorlage.auftrag?.empfaengerAdresse.plz +
              ' ' +
              auftragsvorlage.auftrag?.empfaengerAdresse.ort,
        terminart: auftragsvorlage.auftrag?.terminkennzeichen?.kurzBezeichnung,
        klassifizierung: auftragsvorlage.auftrag?.sperrigkeit?.bezkurz,
      };
    });
  };

  const onDeleteAuftragsvorlage = () => {
    if (selectedRow || selectedRow == 0) {
      const vorlageId: number = data[selectedRow].id;
      if (vorlageId) {
        props.deleteAuftragsvorlage(vorlageId);
      } else {
        setNotification('Technischer Fehler aufgetreten', [], ERROR);
      }
    } else {
      setNotification('Bitte markieren Sie eine Zeile.', []);
    }
  };

  return (
    <Fragment>
      <div className='auftragsvorlagemanagement-wrapper'>
        <Toolbar>
          <Button
            tooltip='Übernehmen'
            classes={'iconButton'}
            key={0}
            onClickHandler={() => applyAuftragsvorlage()}
          >
            <i className='far fa-arrow-alt-circle-down fa-2x' />
          </Button>
          <Button
            tooltip='Auftragsvorlage löschen'
            classes={'iconButton'}
            key={1}
            onClickHandler={() => onDeleteAuftragsvorlage()}
            disabled={!canDeleteTemplate}
          >
            <i className='far fa-trash-alt fa-2x color-red' />
          </Button>
          {props.session.isHauptmandant && (
            <Select
              className='adr-mandant'
              headerTitle='Mandant'
              onChangeHandler={(id?: number) => {
                const mandant = mandanten.find(mandant => mandant.id === id);
                setSelectedMandant(mandant);
              }}
              selectedOptionId={selectedMandant?.id ?? undefined}
              selectData={toSelectOptions(mandanten, 'name')}
            />
          )}
          <div className={'search-field-wrapper'}>
            <i className='fas fa-search fa-lg' />
            <InputFieldText
              label='Name, Empfänger '
              name='search'
              classes='search-field'
              onChangeHandler={setQuery}
              maxlength={200}
              value={query}
            />
          </div>
        </Toolbar>
        <GridCellWrapper
          classes='auftragsvorlagemanagement'
          label='Auftagsvorlage Suche'
        >
          <Table
            tableConfig={tableConfig}
            setTableConfig={setTableConfig}
            data={data}
            tabSkipIndices={[0]}
            edit={false}
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
            searchQueryString={query}
          />
          <Pagination
            onClickHandler={searchStart}
            totalCount={+props.totalSearchResults}
            countPerPage={props.rowsInGrid}
            currentPage={page}
          />
        </GridCellWrapper>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state: StateModel) => ({
  auftragsvorlageliste: state.Auftragsvorlagen.auftragsvorlageliste,
  reloadToggle: state.Auftragsvorlagen.reloadToggle,
  mandantenByHauptmandant: state.Stammdaten.mandanten,
  session: state.UserSession,
  version: state.UserSession.version,
  rowsInGrid: state.UserSession.rowsInGrid,
  totalSearchResults: state.Auftragsvorlagen.totalSearchResults,
});

export default connect(mapStateToProps, {
  searchAuftragsvorlage,
  setVorlageAuftragId,
  setActiveTab,
  getMandantenByHauptmandant,
  deleteAuftragsvorlage,
})(withRouter(AuftragsvorlageManagement));
